<template>
  <div class="teams-list">
    <div class="teams-header">
      <div class="team-header">
        {{ $t('team') }}
      </div>
      <div class="team-header role-header">
        {{ $t('role') }}
      </div>
      <div class="team-header" />
    </div>
    <div
      v-for="team in $store.state.teams"
      :key="team.id"
      class="team-row"
    >
      <div class="team-item team-name">
        <team-icon-name :team="team" />
      </div>
      <div class="team-item team-role">
        {{ $t('roles.'+role(team)) }}
      </div>
      <div
        v-if="!team.isInvited"
        class="team-item controls"
      >
        <button
          v-if="!team.roles.includes('admin') && $store.state.teams.length > 1"
          class="clavo-button clavo-button-danger-secondary"
          :class="{'inactive': leavingTeamStarted}"
          @click="handleLeaveButtonClick(team)"
        >
          {{ $t('leave') }}
        </button>
      </div>
      <div
        v-else
        class="team-item controls"
      >
        <button
          v-if="!team.roles.includes('admin') && $store.state.teams.length > 1"
          class="clavo-button secondary"
          @click="acceptInvitation(team)"
        >
          {{ $t('accept') }}
        </button>
        <button
          v-if="!team.roles.includes('admin') && $store.state.teams.length > 1"
          class="clavo-button clavo-button-danger-secondary"
          @click="rejectInvitation(team)"
        >
          {{ $t('reject') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Color from '@/components/Color'
import TeamIconName from '@/components/Team/TeamIconName'
import ParseFunctions from '@/components/ParseFunctions'
import Constants from '@/components/Constants'
import EventBus from '@/EventBus'

export default {
  components: {
    TeamIconName,
  },
  mixins: [Color, Constants, ParseFunctions],
  data() {
    return {
      teamIconURL: '',
      leavingTeamStarted: false,
    }
  },
  created() {
    EventBus.$on('leave-action-started', this.leaveActionStarted)
    EventBus.$on('leave-action-ended', this.leaveActionEnded)
  },
  beforeDestroy() {
    EventBus.$off('leave-action-started', this.leaveActionStarted)
    EventBus.$off('leave-action-ended', this.leaveActionEnded)
  },
  methods: {
    async acceptInvitation(team){

      let res = await this.acceptExistingUserInvitation(team.teamId)
      if (res.status !== 'ok') {
        EventBus.$emit('new-info-bar-msg', {
          msg: this.$t('joiningTeamFailed', { x: team.name }),
          error: true,
        })
        EventBus.$emit('reload-teams')
      }else {
        EventBus.$emit('new-info-bar-msg', {
          msg: this.$t('successfullyJoinedTeam', { x: team.name }),
        })
        EventBus.$emit('reload-teams')
      }
    },
    async rejectInvitation(team){
      let res = await this.cancelInvitation(team.teamId)
      if (res.status !== 'ok') {
        EventBus.$emit('new-info-bar-msg', {
          msg: this.$t('leavingXTeamFailed', { x: team.name }),
          error: true,
        })
      }
      else{
        EventBus.$emit('new-info-bar-msg', {
          msg: this.$t('successfullyLeftTeam', { x: team.name }),
        })
        EventBus.$emit('reload-teams')
      }
    },
    getURL(team) {
      return team.logo ? team.logo._url : null
    },
    firstLetter(teamName) {
      return teamName.charAt(0)
    },
    handleLeaveButtonClick(team) {
      this.$emit('show-leave-team-popup', team)
    },
    leaveActionStarted() {
      this.leavingTeamStarted = true
    },
    leaveActionEnded() {
      this.leavingTeamStarted = false
    },
  },
}
</script>

<style lang="scss" scoped>
.teams-list {
  display: table;

  .teams-header {
    display: table-header-group;
    font-size: 12px;
    text-transform: uppercase;
    height: 27px;

    .team-header {
      display: table-cell;
      vertical-align: middle;
      border-bottom: 1px solid $soap;
      padding-bottom: 8px;
      @include font-rule('averta-semibold');
    }
  }

  .role-header,
  .team-role {
    padding-left: 20px;
  }

  .team-row {
    display: table-row;
    height: 60px;

    .team-item {
      display: table-cell;
      vertical-align: middle;

      border-bottom: 1px solid $soap;
      font-size: 14px;

      &.team-name {
        width: 40%;
        padding: 12px 0;

        div {
          display: flex;
          align-items: center;

          .team-name-inner-element {
            @include font-rule('averta-bold');
            margin-left: 11px;
          }
        }
      }

      &.team-role {
        @include font-rule('averta-regular');
        width: 25%;
      }

      /* .team-icon {
                    flex-basis: 24px;
                    flex-shrink: 0;

                    vertical-align: middle;
                    width: 24px;
                    height: 24px;
                    border-radius: 50px;
                    margin-right: 10px;

                    &.default-team-icon {
                        @include font-rule("averta-semibold");

                        font-size: 13px;
                        color: #FFFFFF;
                        background-color: $blue;

                        border-radius: 12px;
                        line-height: 24px;
                        text-transform: uppercase;

                         display: flex;
                         //align-items: center;
                         justify-content: center;
                    }
                }*/

      &.controls {
        text-align: right;
        button {
          border: 0;
          min-width: 0;
          &:first-child {
            margin-right: 10px;
          }
          @include respond-below(sm) {
            min-width: auto;
            &:first-child {
              margin-right: 0;
            }
          }
        }
      }
    }
  }
}
</style>
